import { FC } from 'react';
import { useDispatch } from 'react-redux';

import { toast } from 'sonner';
import { BaseModal } from 'wbs-components-lib';

import { BetOutcomeModel } from '@shared/types';

import { useUpdateBetOutcomeMutation } from '@services';

import { AppDispatch, updateBetOutcome } from '@store';

import { BetOutcomeForm, BetOutcomeFormValues } from '../../../BetSystemSettingsForms';

import { BetOutcomeEditModalProps } from './types';
import { getBetOutcomeFormValuesFromModel } from './utils';

export const BetOutcomeEditModal: FC<BetOutcomeEditModalProps> = ({ isOpened, handleClose, betOutcome }) => {
  const dispatch = useDispatch<AppDispatch>();

  const [updateBetOutcomeById, { isLoading: isUpdatingInProgress }] = useUpdateBetOutcomeMutation();

  const handleUpdateBetOutcome = async (values: BetOutcomeFormValues) => {
    const { id: betOutcomeId, eventId: betEventId } = betOutcome;

    const updatedBetOutcome = await updateBetOutcomeById({
      betOutcomeId: betOutcomeId,
      payload: { ...values, eventId: betEventId } as unknown as Omit<BetOutcomeModel, 'resultType' | 'bettors'>,
    }).unwrap();

    dispatch(updateBetOutcome(updatedBetOutcome));

    toast.success('Success: Bet outcome has been updated!');

    handleClose();
  };

  const initialValues = getBetOutcomeFormValuesFromModel(betOutcome);

  return (
    <BaseModal headerTitle="Edit Outcome" isOpened={isOpened} handleClose={handleClose} isFooterNeeded={false}>
      <BetOutcomeForm
        submitButtonCaption="Edit"
        initialValues={initialValues}
        isSubmitting={isUpdatingInProgress}
        onSubmit={handleUpdateBetOutcome}
      />
    </BaseModal>
  );
};
